<list-view #listView [delegate]="this">
  <list-render-items>
    <br />
    <div class="card" *ngFor="let role of listView.items" style="width: 95%; margin: 25px">
      <div class="card-header">
        <div class="row">
          <div class="col-md-12 panel-title">
            <a [routerLink]="[role.name]" style="padding-right: 15px">
              <span class="h4">{{ role.name }}</span>
            </a>
            <span *ngIf="role.description"> - {{ role.description }}</span>
            <a
              *ngIf="role.canDelete && role.id != 1"
              class="btn btn-outline-secondary float-end"
              (click)="remove(role)"
            >
              <mat-icon>delete</mat-icon>
            </a>
            <a
              *ngIf="role.canEdit"
              class="btn btn-outline-secondary float-end"
              [routerLink]="[role.name, 'edit']"
            >
              <mat-icon>edit</mat-icon>
            </a>
          </div>
        </div>
      </div>
      <div class="card-body">
        <ul class="list-inline">
          <li><strong>Permissions:</strong></li>
          <li *ngFor="let resource of role.securedResources">
            &#x25ba;<code> {{ resource.resourceName }}</code> {{ resource.accessList.join(' | ') }}
          </li>
        </ul>
        <ul class="list-inline">
          <li><strong>Members:</strong></li>
          <li
            *ngFor="let member of role.subscriptions"
            style="display: inline-block; padding-right: 10px"
          >
            <person-link [user]="member.displayName" [userCai]="member.cai"></person-link>
          </li>
        </ul>
      </div>
    </div>
  </list-render-items>
</list-view>
